<template>
  <div>
    <b-card>
      <load-profile />
      <b-card-title
        title-tag="h2"
        class="font-weight-bold mb-1"
      >
        {{ $t("notification.title") }}
      </b-card-title>
      <b-card-text class="text-info">
        {{ $t("notification.description") }}
      </b-card-text>

      <validation-observer
        ref="updateNotificationCofigForm"
        #default="{ invalid }"
      >
        <n-form-confirmation
          key="updateNotificationCofigForm"
          :form="$refs.updateNotificationCofigForm"
          :disabled="invalid"
          @submit="validateForm"
        >
          <b-form-group
            v-for="field in fields"
            :key="field.key"
            :label-for="field.key"
            :class="field.class"
          >
            <b-form-checkbox
              v-if="field.type === 'checkbox'"
              :id="field.key"
              :ref="field.key"
              v-model="data[field.key]"
              :name="field.key"
              :value="true"
              :unchecked-value="false"
              :disabled="
                field.key != 'disableAllNotification'
                  ? data.disableAllNotification
                  : false
              "
            >
              {{ $t(field.label) }}
            </b-form-checkbox>
          </b-form-group>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1"
                :loading="loading"
                :disabled="invalid"
              >
                {{ $t("button.saveChanges") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
    <b-card>
      <b-card-title
        title-tag="h2"
        class="font-weight-bold mb-1"
      >
        {{ $t("telegram.title") }}
      </b-card-title>
      <b-card-text class="text-info">
        {{ $t("telegram.description") }}
      </b-card-text>

      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <n-button-loading
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1"
            :loading="loadingUnbindTelegram"
            @submit="handleBindTelegram"
          >
            {{ appStore.isBoundTelegram ? $t('button.unbind'): $t("button.bind_now") }}
          </n-button-loading>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BCardText,
  BFormGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import NButtonLoading from '@/components/NButtonLoading'
import Ripple from 'vue-ripple-directive'
import Repository from '@/repositories/RepositoryFactory'
import NFormConfirmation from '@/components/NFormConfirmation'
import NInput from '@/components/NInput'
import { mapValidationMessage } from '@/libs/helper'
import useJwt from '@/auth/jwt/useJwt'
import useAppStore from '@/store-pinia/useAppStore'
import FormInput from './updateNotification'
import TelegramFormInput from './updateTelegramNotification'

const NotificationConfigRepository = Repository.get('notificationConfig')

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardText,
    BFormGroup,
    BFormCheckbox,
    NButtonLoading,
    NFormConfirmation,
    NInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        disableAllNotification: false,
        onlineNotification: false,
        offlineNotification: false,
        emailNotification: false,
        soundNotification: false,
      },
      loading: false,
      loadingUnbindTelegram: false,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile?.email || this.$store.state.profile?.phone
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName))
    },
  },
  watch: {
    userData: {
      handler() {
        this.appStore.setBoundTelegram(this.userData.isBindTelegram)
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.show()
  },
  methods: {
    handleBindTelegram() {
      if (!this.appStore.isBoundTelegram) {
        window.open(this.userData.bindTelegramUrl, '_blank')
        return
      }

      this.loadingUnbindTelegram = true
      NotificationConfigRepository.unbindTelegram(this.userData.id)
        .then(() => {
          this.appStore.setBoundTelegram(false)
        })
        .finally(() => {
          this.loadingUnbindTelegram = false
        })
    },
    show() {
      NotificationConfigRepository.show()
        .then(response => {
          const data = response?.data?.data
          if (data) {
            this.data = {
              ...data,
            }
          }
        })
        .catch(error => {})
    },
    validateForm() {
      this.$refs.updateNotificationCofigForm.validate().then(success => {
        if (success) {
          this.submit()
        }
      })
    },
    submit() {
      this.loading = true
      NotificationConfigRepository.update(this.data)
        .then(response => {})
        .catch(error => {
          if (error.response?.status === 422) {
            const errorMessage = mapValidationMessage(
              error.response.data.validate,
            )
            this.$refs.updateNotificationCofigForm.setErrors(errorMessage)
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  setup() {
    const fields = FormInput
    const telegramFields = TelegramFormInput
    const appStore = useAppStore()
    return {
      fields,
      telegramFields,
      appStore,
    }
  },
}
</script>
